import { jsx } from "react/jsx-runtime";
import { StaggerFadeContainer } from "@pcln/horizon";
import { ButtonChip, Flex } from "pcln-design-system";
import { useState } from "react";
import analytics from "./analytics/analytics.js";
const QuickActionsChips = (props)=>{
    const { submitQuickActionMessage, hasOtherMessage, quickActions, isSeparatorMsg } = props;
    const [isQuickActionsDisplayed, setQuickActionsDisplayedValue] = useState(true);
    if (!isSeparatorMsg && (!quickActions || !quickActions.length || hasOtherMessage || !isQuickActionsDisplayed)) return null;
    return /*#__PURE__*/ jsx(StaggerFadeContainer, {
        children: /*#__PURE__*/ jsx(Flex, {
            flexDirection: "row",
            alignItems: "center",
            p: 2,
            flexWrap: "nowrap",
            style: {
                overflow: 'auto'
            },
            children: quickActions.map((action, i)=>/*#__PURE__*/ jsx(Flex, {
                    my: 2,
                    mx: 1,
                    alignItems: "center",
                    children: /*#__PURE__*/ jsx(ButtonChip, {
                        size: "md",
                        label: `${action?.emoticon ?? ''} ${action.label}`,
                        color: "text.base",
                        onClick: function() {
                            submitQuickActionMessage(action);
                            setQuickActionsDisplayedValue(false);
                            analytics.log({
                                label: 'dynamicQuickActions',
                                message: 'QUICK_ACTION_CHIPS_CLICKED',
                                content: action.label
                            });
                        }
                    })
                }, `quick-action-button-${i}`))
        })
    });
};
export { QuickActionsChips };
